"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var defaultConfig_1 = require("./ContextProvider/defaultConfig");
exports.default = React.createContext(defaultConfig_1.default);
//# sourceMappingURL=AppContext.js.map